<!-- FIREBASE V9 -->
<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <ProgramMemberDataComponent :uid="uid"></ProgramMemberDataComponent>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="goToItemList">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-form ref="form" lazy-validation class="ma-5 member-form" v-model="valid">
            <v-layout>
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg2-text mr-md-3">วันที่</p>
                </v-flex>
                <v-flex xs12 md3 class="d-md-none">
                    <p class="text-subtitle-1 mr-md-3">วันที่</p>
                </v-flex>
                <v-flex xs12 md3>
                    <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :rules="requiredRule" required v-model="computedDateFormattedDate" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                        </template>
                        <v-date-picker :rules="requiredRule" v-model="editedItem.datepicker" no-title required @input="menu1 = false"></v-date-picker>
                    </v-menu>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.bodyFat" label="BodyFat" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.visceralFat" label="Visceral Fat" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.muscle" label="Muscle Mass" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.bodyAge" label="Body Age" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.rightArmFat" label="ไขมันแขนขวา" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.leftArmFat" label="ไขมันแขนซ้าย" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.rightLegFat" label="ไขมันขาขวา" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.leftLegFat" label="ไขมันขาซ้าย" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4>
                    <v-text-field v-model="editedItem.trunkFat" label="ไขมันหน้าท้อง" type="number"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md4 text-right>
                    <v-btn d-flex color="blue darken-1" text @click="goToItemList"> Cancel </v-btn>
                    <v-btn v-if="this.docId" color="blue darken-1" text @click="submit">
                        Update
                    </v-btn>
                    <v-btn v-else color="blue darken-1" text @click="submit">
                        Add
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import bqGetMemberBodyList from "../data/bqGetMemberBodyList";
import formatData from "../utils/formatData";
import ProgramMemberDataComponent from "../components/ProgramMemberDataComponent.vue";
import setHealthData from "../data/setHealthData";
export default {
    name: 'BodyForm',
    metaInfo: {
        title: 'Body Form'
    },
    components: {
        ProgramMemberDataComponent
    },
    data() {
        return {
            loading: false,
            editedItem: {
                datepicker: "",
                bodyFat: "", 
                visceralFat: "", 
                muscle: "", 
                bodyAge: "", 
                rightArmFat: "", 
                leftArmFat: "", 
                rightLegFat: "", 
                leftLegFat: "", 
                trunkFat: "", 
            },
            //to validate from
            valid: false,
            requiredRule: [
                (value) => !!value || "Required."
            ],
            dialog: false,
            title: "",
            menu1: false,
            formField: ['bodyAge', 'bodyFat', 'category', 'leftArmFat', 'leftLegFat', 'muscle', 'rightArmFat', 'rightLegFat', 'trunkFat', 'visceralFat']
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | องค์ประกอบร่างกาย";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        this.id = this.$route.params.id;
        this.uid = this.$route.params.uid;
        this.docId = this.$route.params.docId;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin"
        ]),
        computedDateFormattedDate() {
            return this.formatDate(this.editedItem.datepicker);
        },
    },
    methods: {
        initialize() {
            if ( this.isAccessCoachAdmin ) {
                (async () => {
                    if (this.docId) {
                        (async () => {
                            const memberBodyData = await bqGetMemberBodyList(this.uid, this.docId);
                            const editData = memberBodyData[0];
                            this.formField.forEach((f) => {
                                if( editData[f] ){
                                    this.editedItem[f] = editData[f] * 1;
                                }
                            });
                            this.editedItem.datepicker = formatData('datepicker', editData.date.value);
                            
                        })();
                    }
                    else{
                        this.editedItem.datepicker = formatData('datepicker', new Date());
                    }
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            if (!value) return null;
            return formatData(type, value);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        submit() {
            (async () => {
                //to validate from before submit
                await this.$refs.form.validate();
                if (this.valid) {
                    const formData = {};
                    this.formField.forEach((f) => {
                        if( this.editedItem[f] ){
                            formData[f] = this.editedItem[f] * 1;
                        }
                    });

                    if( this.docId ){
                        formData.date = new Date(this.editedItem.datepicker + ' 00:00:00');
                        formData.source = 'coach';
                        formData.category = 'fat';
                        formData.updatedDate = new Date();
                        formData.updatedBy = this.loggedInUserId;
                        await setHealthData( formData, this.uid, this.docId );
                    }
                    else{
                        formData.date = new Date(this.editedItem.datepicker + ' 00:00:00');
                        formData.source = 'coach';
                        formData.category = 'fat';
                        formData.createdDate = new Date();
                        formData.createdBy = this.loggedInUserId;
                        formData.updatedDate = new Date();
                        formData.updatedBy = this.loggedInUserId;
                        await setHealthData( formData, this.uid );
                    }
                    setTimeout(() => {
                        this.dialog = true;
                    }, "3000");
                }
            })();
        },
        close() {
            this.dialog = false;
        },
        goToItemList() {
            this.$router.push(`/program/${this.$route.params.mod}/body/${this.id}/${this.uid}`);
        }
    },
};
</script>

<style>
.v-textarea textarea {
    height: 70px;
}

p {
    margin-bottom: 0 !important;
}

p.bg2-text {
    line-height: 56px !important;
    text-align: left;
}

p.bg-text {
    line-height: 55px !important;
    text-align: right;
}

.member-form input[type=number] {
    text-align: right;
}
</style>
